import e from "@dialpad/dialtone-tokens/layered/themes/tokens-fjord-colors.css?inline";
//#region themes/fjord.js
var t = {
	brand: {
		css: e,
		name: "fjord"
	},
	material: { name: "iron" }
};
//#endregion
export { t as default };
